import { render, staticRenderFns } from "./EmptyStatePlaceholder.vue?vue&type=template&id=e563731e"
import script from "./EmptyStatePlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyStatePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports